import { ChangeEvent } from 'react';

export enum InputColorVariant {
  White = 'white',
}

export interface InputProps {
  error?: string;
  success?: boolean;
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  type: string;
  name: string;
  placeholder: string;
  value: string;
  bottomText?: string | null;
  maxLength?: number;
  // identify element for e2e test
  id: string;
  disabled?: boolean;
  className?: string;

  colorVariant?: InputColorVariant;
}
